import { Trans } from '@lingui/react/macro'
import { visitHooks } from '$src/lib/trpcHooks'
import { Button, Card, Group, Stack, Text } from '@mantine/core'
import { formatDateTime } from '@markku/utils'
import { IconCalendar } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'
import dayjs from 'dayjs'

export function UpcomingVisitCard() {
  // Fetch next upcoming visit
  const { data: upcomingVisitsResponse } = visitHooks.useList({
    pageSize: 1,
    orderBy: 'startTime',
    orderDirection: 'asc',
    filters: {
      status: { eq: 'scheduled' },
      startTime: { gte: dayjs().startOf('day').toISOString() },
    },
  })

  const upcomingVisit = upcomingVisitsResponse?.data[0]

  if (!upcomingVisit) {
    return null
  }

  return (
    <Card
      component={Link}
      to={`/visits/${upcomingVisit.id}`}
      radius="lg"
      shadow="xs"
      style={{
        background: 'linear-gradient(135deg, #FFF4E6 0%, #FFE8CC 100%)',
        border: '1px solid var(--mantine-color-brandOrange-2)',
        cursor: 'pointer',
        transition: 'transform 0.2s',
        textDecoration: 'none',
      }}
      p="md"
    >
      <Stack gap="sm">
        <Group gap="xs">
          <IconCalendar size={20} color="var(--mantine-color-brandOrange-6)" />
          <Text fw={500}>
            <Trans>Markku's next visit</Trans>
          </Text>
        </Group>

        <Text size="lg" fw={700} c="dark">
          {upcomingVisit.startTime
            ? formatDateTime(upcomingVisit.startTime)
            : ''}
        </Text>

        <Group grow gap="xs">
          <Button size="sm" radius="md" color="brandOrange" variant="filled">
            <Trans>View visit details</Trans>
          </Button>
        </Group>
      </Stack>
    </Card>
  )
}
